export default __webpack_public_path__ + "static/media/new-floor-3.56af12b0.svg";